import styles from "./AssessmentWho.module.scss";

export const AssessmentWho = () => {
    return (
        <div className={styles.AssessmentWho}>
            <div className={styles.title}>Who is this consultation for?</div>
            <div className={styles.text}>
                Do you often try to relieve fatigue with food, watching TV, or
                playing computer games? If a person is mentally overstrained,
                they try to relieve tension by lying in bed, with food, a TV, or
                a computer game. Often this condition is accompanied by mental
                fatigue. Then, mental overstrain can develop.
            </div>
        </div>
    );
};
